<article class="field-group-container">
  @if (hasGeoLocationValue && !showCoordinateForm()) {
    <div class="wide-map-container">
      @if (!overlay.viewMode()) {
        <app-button-group class="cg-10">
          <app-button
            class="edit-button"
            size="large"
            type="icon"
            [disabled]="!canEditCoordinates()"
            [tp]="
              canEditCoordinates()
                ? translations.editCoordinatesTp
                : translations.editNotSupportedTp
            "
            (pressed)="editCoordinates()"
          >
            <mat-icon>edit</mat-icon>
          </app-button>

          <app-button
            class="edit-button"
            [tp]="translations.removeTp"
            size="large"
            type="icon"
            (pressed)="onDeleteMap(true)"
          >
            <mat-icon>delete</mat-icon>
          </app-button>
        </app-button-group>
      }
      <app-map
        [geoLocation]="
          canEditCoordinates()
            ? formGroup.controls['geoLocation'].value
            : geojson() || formGroup.controls['geoLocation'].value
        "
        [locationName]="formGroup.controls['name'].value"
        [scrollWheelEnabled]="true"
      ></app-map>
    </div>
  } @else {
    @if (showCoordinateForm() && !overlay.viewMode()) {
      <div class="form-container">
        <div class="coordinates-container">
          <div class="buttons-container container-flex-left">
            <div class="container-flex">
              <app-button-group>
                @if (getValidFormGroups().length) {
                  <ng-container>
                    <app-button
                      [tp]="translations.swapTp"
                      size="medium"
                      type="icon"
                      (pressed)="coordinatesFormComponent.swapColumns()"
                    >
                      <mat-icon icon-medium-18>sync_alt</mat-icon>
                    </app-button>
                  </ng-container>
                }

                <app-button
                  [disabled]="
                    coordinatesFormGroups.invalid ||
                    getValidFormGroups().length === maxCoordinatesFormGroups
                  "
                  (pressed)="addArea()"
                  size="medium"
                  type="icon"
                  [tp]="
                    coordinatesFormGroups.invalid
                      ? translations.coordinatesformGroupsInvalidTp
                      : getValidFormGroups().length === maxCoordinatesFormGroups
                        ? translations.coordinatesformGroupsValidButMaxReachedTp
                        : translations.coordinatesformGroupsValidTp
                  "
                >
                  <mat-icon icon-medium-18>add</mat-icon>
                </app-button>
              </app-button-group>
              <mat-icon class="help-icon" [tp]="tooltipHintContent" tpPlacement="right">
                help
              </mat-icon>
            </div>

            <ng-template #tooltipHintContent>
              <div>
                <p>{{ translations.pasteTp }}</p>
                @if (isGpsManualEntryFormatsEnabled) {
                  <p>{{ translations.pasteTpFormat }}</p>
                }
              </div>
            </ng-template>

            @if (isGpsManualEntryFormatsEnabled) {
              <div class="coordinate-format-container" [formGroup]="coordinateFormatFormGroup">
                <app-input-select
                  emitRawValue
                  formControlName="format"
                  [showClear]="false"
                  [inputOnlyMode]="true"
                  [options]="coordinateFormats"
                ></app-input-select>
              </div>
            }
            @if (getValidFormGroups().length) {
              <ng-container>
                <app-button
                  [tp]="translations.removeGpsTp"
                  size="medium"
                  type="icon"
                  (pressed)="onDeleteMap()"
                  [disabled]="!hasGeoLocationValue"
                >
                  <mat-icon icon-medium-18>delete</mat-icon>
                </app-button>
              </ng-container>
            }
          </div>
          @if (getValidFormGroups().length) {
            @if (getValidFormGroups().length === 1) {
              <app-coordinates-form
                [formGroup]="getFormGroup(0)"
                [coordinateFormatFormGroup]="coordinateFormatFormGroup"
                (coordinatesChanged)="onCoordinatesChanged()"
                (removeRadiusArea)="removeRadiusArea()"
              ></app-coordinates-form>
            } @else {
              <mat-tab-group
                animationDuration="0ms"
                mat-stretch-tabs="false"
                mat-align-tabs="start"
                [selectedIndex]="selectedTabIndex()"
                (selectedIndexChange)="selectedTabIndex.set($event); setPolygonAreas()"
                class="no-content-margin no-overflow"
              >
                @for (area of getValidFormGroups(); let index = $index; track index) {
                  <mat-tab [label]="getAreaLabel(index)" labelClass="hover-visibility-container">
                    <ng-template mat-tab-label>
                      <div class="tab-label-container container-flex-space-between">
                        <span class="tab-label" [tp]="translations.areaTp">
                          {{ getAreaLabel(index) }}
                        </span>
                        @if (getValidFormGroups().length > 1) {
                          <app-button
                            type="icon"
                            [tp]="translations.removeAreaTp"
                            (pressed)="$event.stopPropagation(); onDeleteArea(index)"
                            class="delete-area-button on-hover-visibility-show"
                          >
                            <mat-icon icon-small>close</mat-icon>
                          </app-button>
                        }
                      </div>
                    </ng-template>
                    @if (selectedTabIndex() === index) {
                      <app-coordinates-form
                        [formGroup]="getFormGroup(index)"
                        [coordinateFormatFormGroup]="coordinateFormatFormGroup"
                        (coordinatesChanged)="onCoordinatesChanged()"
                        [hasMultipleAreas]="true"
                      ></app-coordinates-form>
                    }
                  </mat-tab>
                }
              </mat-tab-group>
            }
          } @else {
            <div class="container-flex-center">
              <div class="info-hint mt-100 font-size-unset" i18n="@@location-overlay.nogpsdata">
                This location has no GPS data. Add a new area to start adding coordinates.
              </div>
            </div>
          }
        </div>

        <div class="map-container">
          <google-map
            #googleMap
            (idle)="onMapIdle()"
            height="706px"
            width="425px"
            [zoom]="zoom"
            [options]="mapOptions"
          ></google-map>
          @if (errorMessageVisible) {
            <div class="map-warning-container container-flex-center">
              <mat-icon class="warn-icon" svgIcon="alert-triangle" />
              {{ errorMessage }}
            </div>
          }
          <div class="map-area-container container-flex-center text-center">
            @if (getValidFormGroups().length === 1) {
              {{ translations.totalAreaHaText }}: {{ totalAreaHa() | number }}
            } @else if (getValidFormGroups().length > 1) {
              {{ translations.selectedAreaHaText }} ({{ getAreaLabel(selectedTabIndex()) }}) (ha):
              {{ selectedAreaHa() | number }}
              <br />
              {{ translations.totalAreaHaText }}: {{ totalAreaHa() | number }}
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="container-flex-center flex-column gap-row-20">
        <div class="info-hint mt-100 font-size-unset" i18n="@@shared.thislocationhasnogpsdata">
          This location has no GPS data
        </div>
        @if (!overlay.viewMode()) {
          <app-button (pressed)="addGpsData.emit()" type="ghost">
            <mat-icon icon-left>add</mat-icon>
            <ng-container i18n="@@action.add">Add</ng-container>
          </app-button>
        }
      </div>
    }
  }
</article>
